import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async'; // Import HelmetProvider and Helmet
import Header from './components/Header';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
// import Schedule from './components/Schedule';
import Footer from './components/Footer';
import About from './components/About';
import Home from './components/Home';
import Chefs from './components/Chefs';
import BlogPost from './components/BlogPost';
import Toast from './components/Toast';
import FloatingCart from './components/FloatingCart';
import FloatingContact from './components/FloatingContact';
import './App.css';
import PhotoGallery from './components/PhotoGallery';
import SubscriptionCustomization from './components/SubscriptionCustomization';

import emailjs from '@emailjs/browser';

document.title = "Folsom Microgreens"

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    emailjs.init("PfL3QsTk4pTUONQvR"); // Replace with your EmailJS user ID
    
    // Load cart from localStorage
    const savedCart = localStorage.getItem('folsom-microgreens-cart');
    if (savedCart) {
      try {
        setCartItems(JSON.parse(savedCart));
      } catch (error) {
        console.error('Error loading cart from localStorage:', error);
      }
    }
  }, []);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('folsom-microgreens-cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    const newItem = { ...product, id: Date.now() };
    setCartItems([...cartItems, newItem]);
    
    // Show toast notification
    setToast({
      message: `${product.name} added to cart!`,
      onClose: () => setToast(null)
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems(cartItems.filter(item => item.id !== itemId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <HelmetProvider>
      <Router >
        <div className="App">
          <Helmet>
            <title>Folsom Microgreens - Premium Microgreens for Businesses</title>
            <meta name="description" content="High-quality, locally grown microgreens for restaurants, cafes, and food businesses in Folsom and Sacramento area." />
            <meta name="keywords" content="microgreens, local, Folsom, homegrown, harvest, sustainable, nutrient-dense, food, business" />
          </Helmet>
          <Header cartItemsCount={cartItems.length} />

          <main>
            
            <Routes>
            <Route path="/" element={<Home />} />
              <Route path="/chefs" element={<Chefs />} />
              <Route path="/about" element={<About />} />
              <Route path="/photogallery" element={<PhotoGallery />} />
              <Route path="/microgreens" element={<ProductList addToCart={addToCart} />} />
              <Route path="/product/:id" element={<ProductDetail addToCart={addToCart} />} />
              <Route path="/cart" element={<Cart items={cartItems} removeFromCart={removeFromCart} clearCart={clearCart} />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/subscription-customize" element={<SubscriptionCustomization addToCart={addToCart} />} />
            </Routes>
          </main>
          <Footer />
          
          {/* Floating Cart Button */}
          <FloatingCart cartItemsCount={cartItems.length} />

          {/* Floating Contact Widget — shifts up when the cart pill is visible */}
          <FloatingContact offset={cartItems.length > 0} />
          
          {/* Toast Notification */}
          {toast && <Toast message={toast.message} onClose={toast.onClose} />}
        </div>
      </Router>

    </HelmetProvider>
    
  );
}

export default App;